<template>
  <span class="stwrap">
    <button v-if="scheduled" class="stbtn sched" type="button" disabled>On schedule</button>
    <button v-if="scheduled" class="stbtn force" type="button" @click="toggleForce">Force</button>
    <button
      v-if="!scheduled"
      class="stbtn"
      :class="sl.status === 'ACTIVE' ? 'active' : 'paused'"
      type="button"
      :disabled="slToggleBlocked(sl)"
      :title="slToggleTitle(sl)"
      @click="toggleStatus"
    >{{ sl.status === 'ACTIVE' ? 'Active' : 'Paused' }}</button>
    <SlRelaunch :sl="sl" @relaunched="$emit('relaunched', sl)" />
    <button v-if="sl.forced" class="stbtn unforce" type="button" @click="toggleForce">Unforce</button>
  </span>
</template>

<script>
import SlRelaunch from '../SlRelaunch.vue'
import { confirmSlActivation, canActivateSl, slToggleBlocked, slToggleTitle } from '../../utils.smartlinks'

export default {
  name: 'SlV2Status',
  components: { SlRelaunch },
  props: {
    sl: { type: Object, required: true }
  },
  computed: {
    scheduled() {
      return !!(this.sl.scheduled && !this.sl.forced)
    }
  },
  methods: {
    slToggleBlocked,
    slToggleTitle,
    async toggleForce() {
      try {
        this.sl.forced = !this.sl.forced
        this.sl.group_forced = this.sl.forced
        await this.$http.put(this.resources.SmartLinksCampaigns.setForcedCampaignStatus(this.sl.id), {
          id: this.sl.id,
          group_forced: this.sl.forced,
          group_id: this.sl.group_id
        })
        this.$emit('changed')
        this.notifySuccess(this.sl.forced
          ? `Campaign ${this.sl.name} is no longer managed by its group scheduler`
          : `Campaign ${this.sl.name} is now managed by its group scheduler`)
      } catch (err) {
        this.sl.forced = !this.sl.forced
        this.notifyError('could not toggle force status')
      }
    },
    toggleStatus() {
      if (!this.userHasPermission('smartlinks.status-change')) return
      const toStatus = this.sl.status === 'ACTIVE' ? 'PAUSED' : 'ACTIVE'
      if (toStatus === 'ACTIVE') {
        if (!canActivateSl(this.sl)) {
          this.notifyError(`"${this.sl.name}" has no offers with a weight above 0.`)
          return
        }
        if (!confirmSlActivation(this.sl)) return
      } else if (!window.confirm(`Pause "${this.sl.name}"?`)) {
        return
      }
      this.$http.put(this.resources.SmartLinksCampaigns.setCampaignStatus(this.sl.id), { status: toStatus })
        .then(() => {
          this.sl.status = toStatus
          this.$emit('changed')
        })
        .catch(() => this.notifyError('Could not change status'))
    }
  }
}
</script>
